// possible values for GridCellType type
import { ColumnType } from '../../../types/common';

export type GridCellType =
  | ColumnType.ENUM
  | ColumnType.STRING
  | ColumnType.NUMBER
  | ColumnType.EDITABLE_SELECT
  | ColumnType.CHECKBOX;

export enum CellEditEvents {
  SAVE = 'cellEditSave',
  CANCEL = 'cellEditCancel',
}
